import { makeAutoObservable } from "mobx";
import { AttributeShelf } from "../AttributeShelf";
import { MIN_YEARS_ANTICIPATION } from "../../constants";
import type { TotalSimulationInstallments } from "../../services/APIService/types";

export class TotalAnticipationShelf {
	public numberOfInstallments = new AttributeShelf(0);
	public maxFGTSValueAvailable = new AttributeShelf(0);
	public blockedValue = new AttributeShelf(0);
	public contractFees = new AttributeShelf(0);
	public IOF = new AttributeShelf(0);
	public CET = new AttributeShelf(0);
	public yearsFees = new AttributeShelf(0);
	public monthFees = new AttributeShelf(0);
	public yearsAdvance = new AttributeShelf(0);
	public disbursedIssueAmount = new AttributeShelf(0);
	public refSelectYears = new AttributeShelf(0);
	public refMaxFGTSValueAvailable = new AttributeShelf(0);
	public installments = new AttributeShelf<TotalSimulationInstallments[] | []>([]);
	public tacAmount = new AttributeShelf(0);

	constructor() {
		makeAutoObservable(this);
	}

	public get isMinimumYears(): boolean {
		return this.yearsAdvance.value === MIN_YEARS_ANTICIPATION;
	}
	public get isMaximumYears(): boolean {
		return this.yearsAdvance.value === this.refSelectYears.value || this.yearsAdvance.value >= 10;
	}
}
